import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';
import CrmSyncAccountAndOpportunitiesStore from 'stores/crm/CrmSyncAccountAndOpportunitiesStore';
import CallSyncCRMStore from 'stores/crm/CallSyncCRMStore';
import CrmSyncContactsAndLeadsPrefixSearchStore from 'stores/crm/CrmSyncContactsAndLeadsPrefixSearchStore';
import CallSyncCRMDialog from 'components/pure/call-card/CallSyncCRMDialog';

/**
 * CallSyncCRMDialogContainer is an AltContainer for <CallSyncCRMDialog/>
 */
class CallSyncCRMDialogContainer extends React.Component {
  static getStores() {
    return [
      CrmSyncAccountAndOpportunitiesStore,
      CrmSyncContactsAndLeadsPrefixSearchStore,
      CallSyncCRMStore,
    ];
  }

  static getPropsFromStores() {
    const accountAndOpportunitiesState = CrmSyncAccountAndOpportunitiesStore.getState();
    const contactsAndLeadsState = CrmSyncContactsAndLeadsPrefixSearchStore.getState();
    return {
      accountsAndOpportunities: accountAndOpportunitiesState.get('values'),
      contactsAndLeads: contactsAndLeadsState.get('values'),
    };
  }

  render() {
    return (
      <AltContainer>
        <CallSyncCRMDialog {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(CallSyncCRMDialogContainer);
